/* ---------------------------------------------------------------------------
   Keyboard access for the header dropdowns. 18 Sept 2026.

   Found during the keyboard pass: the theme opens a header submenu on mouseenter
   and nothing opens it on focus, so the three dropdowns were mouse-only. Measured
   on the bamboo PDP: the Bannetons item holds 3 submenu links and 0 of them were
   reachable by keyboard.

   Fixed here rather than in CSS on purpose. A :focus-within rule would make the
   panel visible and its links tabbable while they still carried aria-hidden="true",
   which is the exact anti-pattern of a control a screen reader cannot see. This
   flips the same aria-hidden attribute the theme's own script uses, so the links
   become visible and announced together, and the CSS that already keys off
   [aria-hidden="false"] does the showing.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var ITEM = '.nav-bar__item';
  var PANEL = '.nav-dropdown';

  function panelOf(item) { return item.querySelector(PANEL); }
  function triggerOf(item) { return item.querySelector('a, button'); }

  function open(item) {
    var panel = panelOf(item);
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'false');
    var trigger = triggerOf(item);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function close(item) {
    var panel = panelOf(item);
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'true');
    var trigger = triggerOf(item);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function init() {
    var items = [].slice.call(document.querySelectorAll(ITEM)).filter(panelOf);
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = triggerOf(item);
      if (trigger && !trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      item.addEventListener('focusin', function () {
        open(item);
      });

      /* relatedTarget is where focus is heading. It is null when focus leaves the
         document entirely, which also counts as leaving the menu. */
      item.addEventListener('focusout', function (event) {
        if (!event.relatedTarget || !item.contains(event.relatedTarget)) close(item);
      });

      /* Escape closes the panel and puts focus back on the top level link, so the
         customer is not dropped somewhere else in the tab order. */
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        close(item);
        var back = triggerOf(item);
        if (back) back.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
